import StoreLayout from "../../../components/store-layout.js";

const Plants = () => {
  return (
    <>
      <h1>Plants</h1>
      <StoreLayout type={"plants"} />
    </>
  );
}

export default Plants;